export const GoToHowItWorks = () => {
  return (
    <div>
      <div>
        <h5>1. Connect your GoTo account</h5>
        <div className='mt-2'>Zocks redirects you to GoTo, where you can authorize the access request and set up the connection.</div>
      </div>
      <div className='mt-3'>
        <h5>2. Record calls in GoTo Connect</h5>
        <div className='mt-2'>Calls must be recorded by GoTo Connect before Zocks can process them.</div>
        <div className='mt-2'>
          You can configure GoTo Connect to record calls automatically, or users can manually record individual calls when needed. Recording behavior is managed
          in GoTo Connect, not in Zocks.
        </div>
      </div>
      <div className='mt-3'>
        <h5>3. Zocks processes available GoTo recordings</h5>
        <div className='mt-2'>After a recorded call ends, Zocks checks for the GoTo recording and processes it when it becomes available.</div>
        <div className='mt-2'>
          Zocks can match recorded calls to scheduled meetings by phone number, or create a new meeting record for unexpected recorded calls.
        </div>
        <div className='mt-2'>
          If no GoTo recording exists for the call, Zocks will not generate notes, summaries, transcripts, or CRM updates from that call.
        </div>
      </div>
      <div className='mt-4'>
        <h5>Recommended GoTo setup</h5>
        <div className='mt-2'>
          For the best experience, enable GoTo Connect call recording for the phone numbers, users, extensions, queues, or call flows that should be processed
          by Zocks.
        </div>
        <div className='mt-2'>
          We recommend enabling recording for both inbound and outbound calls, and ensuring API access for recordings is enabled in GoTo Admin.
        </div>
        <div className='mt-2'>
          Your organization is responsible for configuring GoTo recording settings, recording consent, storage, and retention according to your internal
          policies and applicable regulations.
        </div>
      </div>
    </div>
  )
}
